import { cn } from '../../lib/utils';

type BadgeVariant = 'success' | 'warning' | 'destructive' | 'default' | 'primary';

const variantStyles: Record<BadgeVariant, string> = {
  success: 'text-success bg-success/10 border-success/20',
  warning: 'text-warning bg-warning/10 border-warning/20',
  destructive: 'text-destructive bg-destructive/10 border-destructive/20',
  default: 'text-muted-foreground bg-muted/40 border-border',
  primary: 'text-primary bg-primary/10 border-primary/20',
};

const dotStyles: Record<BadgeVariant, string> = {
  success: 'bg-success',
  warning: 'bg-warning',
  destructive: 'bg-destructive',
  default: 'bg-muted-foreground',
  primary: 'bg-primary',
};

interface StatusBadgeProps {
  label: string;
  variant: BadgeVariant;
  live?: boolean;
  className?: string;
}

export function StatusBadge({ label, variant, live, className }: StatusBadgeProps) {
  return (
    <span className={cn('inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs font-medium', variantStyles[variant], className)}>
      <span className={cn('h-1.5 w-1.5 rounded-full', dotStyles[variant], live && 'live-dot')} />
      {label}
    </span>
  );
}
